import { mainSiteUrl } from '@/mocks/categories';

interface HeroSectionProps {
  onCategoryClick: () => void;
  onArticleClick: () => void;
}

export default function HeroSection({ onCategoryClick, onArticleClick }: HeroSectionProps) {
  return (
    <section className="relative min-h-[580px] md:min-h-[680px] flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20and%20lifestyle%20products%20elegantly%20arranged%20on%20a%20clean%20cream%20colored%20surface%20with%20soft%20diffused%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20modern%20boutique%20display%2C%20sneakers%20hoodies%20accessories%20scattered%20harmoniously%2C%20subtle%20shadows%2C%20elegant%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-line text-accent-400 text-sm"></i>
            <span className="text-xs md:text-sm text-background-50 font-medium">Aktualne listy produktów 2026</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            Kakobuy Spreadsheet Polska –
            <br />
            <span className="text-accent-400">Twoje centrum</span> najlepszych znalezisk produktowych
          </h1>

          <p className="text-sm md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
            Znajduj popularne produkty szybciej dzięki aktualnym listom Kakobuy Spreadsheet, szczegółowym poradnikom oraz sprawdzonym wskazówkom zakupowym.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base"></i>
              Przejdź do Kakobuy Spreadsheet
            </a>
            <button
              onClick={onArticleClick}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold text-background-50 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/30 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-book-open-line text-base"></i>
              Zobacz poradniki
            </button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-background-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Aktualne listy produktów
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Poradniki dla początkujących
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Analiza bezpieczeństwa
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Darmowy dostęp
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}